import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACS_DocOrderForServices = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACS_DocOrderForServices' className='file-pdf-document'>
            <div className='file-template'>

                <p><strong>Check One: </strong>&nbsp;&nbsp;
                    <input type="checkbox" id="cbInitialService" name="cbInitialService" className='add-only' value="Initial Service" /> Initial Service&nbsp;&nbsp;
                    <input type="checkbox" id="cbReauthorizedService" name="cbReauthorizedService" className='add-only' value="Reauthorized Service" /> Reauthorized Service
                </p>
                <h4>Check Appropriate Box for Service Order</h4>
                <table>
                    <tr>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-725'><strong>Official Group Name</strong></td>
                    </tr>
                    <tr>
                        <td className='w-25'>
                            <input type="checkbox" id="cbOffGrpNm_DiagnosticAssessment" name="cbOffGrpNm" className='add-only' value="Diagnostic Assessment (Psychiatrist) (NP)" />
                        </td>
                        <td className='w-725'>Diagnostic Assessment (Psychiatrist) (NP)</td>
                    </tr>
                    <tr>
                        <td className='w-25'>
                            <input type="checkbox" id="cbOffGrpNm_PsychiatricTreatmentNew" name="cbOffGrpNm" className='add-only' value="Psychiatric Treatment New and Established Patient" />
                        </td>
                        <td className='w-725'>Psychiatric Treatment New and Established Patient</td>
                    </tr>
                    <tr>
                        <td className='w-25'>
                            <input type="checkbox" id="cbOffGrpNm_NursingAssessmentCare" name="cbOffGrpNm" className='add-only' value="Nursing Assessment & Care" />
                        </td>
                        <td className='w-725'>Nursing Assessment & Care</td>
                    </tr>
                    <tr>
                        <td className='w-25'>
                            <input type="checkbox" id="cbOffGrpNm_PsychologicalEvaluation" name="cbOffGrpNm" className='add-only' value="Psychological Evaluation" />
                        </td>
                        <td className='w-725'>Psychological Evaluation</td>
                    </tr>
                    <tr>
                        <td className='w-25'>
                            <input type="checkbox" id="cbOffGrpNm_IndOutCounsel" name="cbOffGrpNm" className='add-only' value="Individual Outpatient Counseling" />
                        </td>
                        <td className='w-725'>Individual Outpatient Counseling</td>
                    </tr>
                    <tr>
                        <td className='w-25'><input type="checkbox" id="cbOffGrpNm_MedAdmin" name="cbOffGrpNm" className='add-only' value="Medication Administration" /></td>
                        <td className='w-725'>Medication Administration</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="small w-600">Physician Signature (w/credentials)</td>
                        <td className="small w-150">Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="small w-600">Physician Print (w/credentials)</td>
                        <td className="small w-150">Date</td>
                    </tr>
                </table>







            </div>
        </form>

    )
}    